import React, { cloneElement } from 'react';

type TitleHeaderProps = {
  title: string;
  icon: React.ReactElement;
};

export const TitleHeader = ({ title, icon }: TitleHeaderProps) => {
  const defaultIconClassName = "h-6 w-6 text-gray-800";

  const iconWithClassName = cloneElement(icon, {
    className: `${icon.props.className || ''} ${defaultIconClassName}`.trim(),
  });

  return (
    <div className="pb-2 mb-4 border-b border-gray-200">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          {iconWithClassName}
          <h1 className="text-2xl font-bold text-gray-800">{title}</h1>
        </div>
      </div>
    </div>
  );
};
